import TabName from "../../../components/controls/CustomTabs/TabName";
import { AuditLogsDataType} from "../../../interface";
import AuditLogsDataTable from "../AuditLogsDataTable/AuditLogsDataTable";

export const TabsAuditConfig = (
  limits: any,
  nextKey: any,
  prevKey:any,
  allLoading: boolean,
  allTotal: number,
  allRecordWithSearch: AuditLogsDataType[],
  setLimits: React.Dispatch<React.SetStateAction<any>>,
  setNextPageKey:React.Dispatch<React.SetStateAction<any>>,
) => [

  {
    id: 1,
    tabName: (
      <TabName
        isLoading={allLoading}
        currentCount={allRecordWithSearch?.length}
        totalCount={allTotal}
        label="All"
      />
    ),
    tabContent: (
      <AuditLogsDataTable
        rows={allRecordWithSearch}
        isLoading={allLoading}
        totalRecord={allTotal}
        limit={limits.all}
        nextKey={nextKey}
        prevKey={prevKey}
        updateLimit={(val) => setLimits((prev: any) => ({ ...prev, all: val }))}
        updateKey={(val) => setNextPageKey((prev: any) => ({ ...prev, val }))}
      />
    ),
  }
];
